import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Link } from "react-router-dom";
import { AuthShell } from "./Signup";
import { Check, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const { sendPasswordReset } = useAuth();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const { error } = await sendPasswordReset(email);
    if (error) setError(error.message);
    else setSent(true);
    setBusy(false);
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll send you a magic link to reset it.">
      {sent ? (
        <div className="bg-white rounded-[20px] p-6 shadow-card text-center" data-testid="forgot-success">
          <div className="w-12 h-12 rounded-full bg-rose/10 flex items-center justify-center mx-auto mb-3">
            <Check className="text-rose" size={20} />
          </div>
          <h3 className="font-serif text-2xl text-cocoa mb-2">Check your email</h3>
          <p className="text-sm text-cocoa/65 font-light">We've sent reset instructions to {email}.</p>
          <Link to="/login" className="mt-5 inline-block text-rose font-medium text-sm" data-testid="forgot-back-login">
            ← Back to login
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3" data-testid="forgot-form">
          <input
            type="email"
            required
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="forgot-email"
            className="w-full rounded-full bg-white border border-cocoa/10 px-5 py-3.5 text-sm placeholder:text-cocoa/40 focus:outline-none focus:ring-2 focus:ring-rose/40"
          />
          {error && <p className="text-sm text-red-500 font-light px-2" data-testid="forgot-error">{error}</p>}
          <button
            type="submit"
            disabled={busy}
            data-testid="forgot-submit"
            className="w-full rounded-full bg-rose hover:bg-rose-dark text-white py-3.5 font-medium transition-all shadow-rose flex items-center justify-center gap-2"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
          </button>
          <Link
            to="/login"
            className="block text-center text-sm text-cocoa/60 mt-3 hover:text-rose"
            data-testid="forgot-back-link"
          >
            ← Back to login
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
